import styles from './PageBits.module.css';

/* ────────────────────────── PageHead ────────────────────────── */

export function PageHead({ title, subtitle, actions, hero = false }) {
  if (hero) {
    return (
      <div className={styles.pageHero}>
        <div className={styles.pageHeroText}>
          <div className={styles.pageHeroTitle}>{title}</div>
          {subtitle && <div className={styles.pageHeroSub}>{subtitle}</div>}
        </div>
        {actions && <div className={styles.heroActions}>{actions}</div>}
      </div>
    );
  }
  return (
    <div className={styles.pageHead}>
      <div>
        <div className={styles.pageTitle}>{title}</div>
        {subtitle && <div className={styles.pageSub}>{subtitle}</div>}
      </div>
      {actions && <div className={styles.pageActions}>{actions}</div>}
    </div>
  );
}

/* ────────────────────────── StatGrid + StatCard ────────────────────────── */

const TONES = ['pu', 'gr', 'am', 'bl'];

export function StatGrid({ cards, loading }) {
  if (loading) {
    return (
      <div className={styles.statGrid}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className={styles.statSkeleton}>
            <div className={`skeleton ${styles.skelLabel}`} />
            <div className={`skeleton ${styles.skelVal}`} />
            <div className={`skeleton ${styles.skelSub}`} />
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className={styles.statGrid}>
      {cards.map((c, i) => (
        <StatCard key={c.label} tone={TONES[i % TONES.length]} {...c} />
      ))}
    </div>
  );
}

export function StatCard({ tone = 'pu', label, value, sub, icon }) {
  return (
    <div className={`${styles.stat} ${styles[tone] || ''} ${icon ? styles.hasIcon : ''}`}>
      {icon && <span className={styles.statIcon}><i className={`bi bi-${icon}`} aria-hidden="true" /></span>}
      <div className={styles.statLabel}>{label}</div>
      <div className={styles.statVal}>{value}</div>
      {sub && <div className={styles.statSub}>{sub}</div>}
    </div>
  );
}
